export default {
    meetStatusList: [
        {value: -1, label: '已结束'},
        {value: 0, label: '直播中'},
        {value: 1, label: '待开始'}
    ]
}